module.exports = __webpack_public_path__ + "img/speaking.301b1fd5.png";